import { AnnouncementCreate_announcementCreate_errors } from "@saleor/announcements/types/AnnouncementCreate";
import { commonMessages } from "@saleor/intl";
import { AnnouncementErrorCode } from "@saleor/types/globalTypes";
import { IntlShape } from "react-intl";

import commonErrorMessages from "./common";

function getAnnouncementErrorMessage(
  err:
    | Omit<AnnouncementCreate_announcementCreate_errors, "__typename">
    | undefined,
  intl: IntlShape
): string {
  if (err) {
    switch (err.code) {
      case AnnouncementErrorCode.REQUIRED:
        return intl.formatMessage(commonMessages.requiredField);
      case AnnouncementErrorCode.INVALID:
        return intl.formatMessage(commonErrorMessages.invalid);
      default:
        return intl.formatMessage(commonErrorMessages.unknownError);
    }
  }

  return undefined;
}

export default getAnnouncementErrorMessage;
